import TopRankFilter from './TopRankFilter'
import withTopRankFilter from './withTopRankFilter'

const ConnectedTopRankFilter = withTopRankFilter(TopRankFilter)

export { ConnectedTopRankFilter as TopRankFilter }
